var DataPrivacyConsentType;
(function (DataPrivacyConsentType) {
  DataPrivacyConsentType[DataPrivacyConsentType["LEGITIMATE_INTEREST"] = 0] = "LEGITIMATE_INTEREST";
  DataPrivacyConsentType[DataPrivacyConsentType["IMPLICIT"] = 1] = "IMPLICIT";
  DataPrivacyConsentType[DataPrivacyConsentType["SEPARATE"] = 2] = "SEPARATE";
})(DataPrivacyConsentType || (DataPrivacyConsentType = {}));
const moduleDataPrivacyResolveConsentType = ({
  processingConsentType,
  isLegitimateInterest
}) => {
  if (processingConsentType && isLegitimateInterest) {
    return DataPrivacyConsentType.LEGITIMATE_INTEREST;
  }
  if (processingConsentType === 'IMPLICIT') {
    return DataPrivacyConsentType.IMPLICIT;
  }
  if (processingConsentType) {
    return DataPrivacyConsentType.SEPARATE;
  }
  return null;
};
const moduleDataPrivacyGenerateCommunicationConsentCheckboxesProperties = ({
  communicationConsentCheckboxes,
  id
}) => (communicationConsentCheckboxes || []).map(({
  communicationTypeId,
  label,
  required
}) => ({
  id,
  type: 'singleCheckbox',
  propertyReference: `LEGAL_CONSENT.subscription_type_${communicationTypeId}`,
  label,
  required,
  conditionallyHidden: false,
  triggerDependentRulesOnLoad: false
}));
const moduleDataPrivacyGenerateProcessingConsentCheckboxProperty = ({
  id,
  processingConsentCheckboxLabel
}) => ({
  id,
  type: 'singleCheckbox',
  propertyReference: 'LEGAL_CONSENT.processing',
  label: processingConsentCheckboxLabel,
  required: true,
  conditionallyHidden: false,
  triggerDependentRulesOnLoad: false
});
export const moduleDataPrivacyResolvePropertyModules = module => {
  switch (moduleDataPrivacyResolveConsentType(module)) {
    case DataPrivacyConsentType.IMPLICIT:
      return moduleDataPrivacyGenerateCommunicationConsentCheckboxesProperties(module);
    case DataPrivacyConsentType.SEPARATE:
      return [...moduleDataPrivacyGenerateCommunicationConsentCheckboxesProperties(module), moduleDataPrivacyGenerateProcessingConsentCheckboxProperty(module)];
    default:
      return [];
  }
};